import React, { useState, useEffect, useRef } from "react";
import { Autocomplete, TextField, Avatar } from "@mui/material";
import { API_ENDPOINT } from "../../../../../constants/constants";
export default function CountrySelector({
  selectedCountry,
  selectedCountryCode,
  onChange,
  required,
}) {
  const [countries, setCountries] = useState([]);
  const hasSetInitial = useRef(false); // Track initial setup

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}/visitor/get-countries`);
        const data = await response.json();
        const countryData = data.map((country) => ({
          name: country.name.common,
          code: country.cca2,
          flag: country.flags.png,
        }));
        setCountries(countryData);

        // Only set initial value once on mount
        if (!hasSetInitial.current) {
          hasSetInitial.current = true;

          if (!selectedCountry && selectedCountryCode) {
            const defaultCountry = countryData.find(
              (country) => country.code === selectedCountryCode
            );
            if (defaultCountry && onChange) {
              onChange(defaultCountry);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []); // Empty dependency array = run only once

  const handleChange = (event, value) => {
    onChange?.(value);
  };

  return (
    <Autocomplete
      size="small"
      options={countries}
      value={selectedCountry || null}
      onChange={handleChange}
      getOptionLabel={(option) => (option ? option.name : "")}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      renderOption={(props, option) => (
        <li {...props}>
          <Avatar
            src={option.flag}
            alt={option.name}
            sx={{ width: 24, height: 24, marginRight: 1 }}
          />
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          label="Select Country"
          variant="outlined"
        />
      )}
    />
  );
}
